import React from 'react';
import type FullCalendar from '@fullcalendar/react';
import { type DatesSetArg } from '@fullcalendar/core';
import { Divider, Grid, IconButton, Tooltip, Typography } from '@mui/material';

import { type PaginationType } from 'app/main/components/hooks/usePagination';
import useSettings from 'app/main/components/hooks/useSettings';
import Icon from 'app/main/components/Icon';
import PaginationButtons from '../../pagination/PaginationButtons';

interface ViewCalendarToolbarProps {
	module: string;
	calendarRef: React.RefObject<FullCalendar | null>;
	datesRange?: DatesSetArg;
	filterProps: PaginationType['filterProps'];
}

const views = {
	dayGridMonth: {
		title: 'CALENDAR_TOOLTIP_MONTH',
		icon: 'calendar-month'
	},
	timeGridWeek: {
		title: 'CALENDAR_TOOLTIP_WEEK',
		icon: 'calendar-week'
	},
	timeGridDay: {
		title: 'CALENDAR_TOOLTIP_DAY',
		icon: 'view-day'
	}
};

export default function ViewCalendarToolbar(props: ViewCalendarToolbarProps) {
	const { settings, t } = useSettings(props.module);

	const calendarApi = () => props.calendarRef.current?.getApi();

	const visibleFilters = settings?.filter_types?.some(filterType => filterType.filt_visible);

	if (calendarApi !== undefined)
		return (
			<div className="flex flex-col items-center justify-between p-8 sm:flex-row">
				<div className="flex items-center justify-center">
					{/* <ListRefreshButton isLoading={isLoading} updateRefresh={updateRefresh} /> */}
					<Tooltip title={t('CALENDAR_TOOLTIP_PREVIOUS')}>
						<IconButton size="small" onClick={() => calendarApi()?.prev()}>
							<Icon icon="chevron-left" />
						</IconButton>
					</Tooltip>
					<Typography className="mx-8" variant="subtitle1">
						{props.datesRange?.view.title}
					</Typography>
					<Tooltip title={t('CALENDAR_TOOLTIP_NEXT')}>
						<IconButton size="small" onClick={() => calendarApi()?.next()}>
							<Icon icon="chevron-right" />
						</IconButton>
					</Tooltip>
				</div>
				<div className="flex">
					<Grid container spacing={1}>
						<Grid>
							<PaginationButtons
								module={settings?.modu_title}
								filterProps={props.filterProps}
								visibleFilters={visibleFilters}
								showFilters
								showExportButton={false}
							/>
						</Grid>
						<Grid>
							<Divider orientation="vertical" />
						</Grid>
						<Grid>
							<Tooltip title={t('CALENDAR_TOOLTIP_TODAY')}>
								<div>
									<IconButton size="small" onClick={() => calendarApi()?.today()}>
										<Icon icon="calendar-today" />
									</IconButton>
								</div>
							</Tooltip>
						</Grid>
						{Object.entries(views).map(([name, view]) => (
							<Grid key={name}>
								<Tooltip title={t(view.title)}>
									<div>
										<IconButton
											size="small"
											onClick={() => calendarApi()?.changeView(name)}
											disabled={props.datesRange?.view.type === name}
										>
											<Icon icon={view.icon} />
										</IconButton>
									</div>
								</Tooltip>
							</Grid>
						))}
					</Grid>
				</div>
			</div>
		);

	return <></>;
}
